import { supabase } from './supabase';

/**
 * Initialize the database schema
 * This function checks if tables exist and creates them if they don't
 */
export async function initializeDatabaseSchema() {
  try {
    console.log('Initializing database schema...');
    
    // Check if advertisements table exists
    const { error: tableError } = await supabase.from('advertisements')
      .select('id')
      .limit(1);

    if (tableError?.message?.includes('relation "advertisements" does not exist')) {
      // Create advertisements table using raw SQL query
      const { error: createError } = await supabase.from('advertisements').insert({
        id: '00000000-0000-0000-0000-000000000000',
        title: 'Dummy Record',
        description: 'Temporary record for table creation',
        image_url: 'https://example.com/dummy.jpg',
        start_date: new Date(),
        end_date: new Date()
      });

      if (createError && !createError.message.includes('already exists')) {
        console.error('Error creating advertisements table:', createError);
        return false;
      }
    }
    
    // Create storage bucket for advertisement images if it doesn't exist
    const { data: buckets } = await supabase.storage.listBuckets();
    const adBucketExists = buckets?.some(bucket => bucket.name === 'advertisement-images');
    
    if (!adBucketExists) {
      await supabase.storage.createBucket('advertisement-images', {
        public: true
      });
    }
    
    console.log('Database schema initialized successfully');
    return true;
  } catch (error) {
    console.error('Error initializing database schema:', error);
    return false;
  }
}

/**
 * Create stored procedures for database operations
 * Note: This is now a no-op since we're not using stored procedures
 */
export async function createStoredProcedures() {
  return true; // No longer needed as we're using direct table operations
}